import { render, staticRenderFns } from "./UpgradeToPlus.vue?vue&type=template&id=2a0a2cba&scoped=true"
import script from "./UpgradeToPlus.vue?vue&type=script&lang=js"
export * from "./UpgradeToPlus.vue?vue&type=script&lang=js"
import style0 from "./UpgradeToPlus.vue?vue&type=style&index=0&id=2a0a2cba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0a2cba",
  null
  
)

export default component.exports